import React from "react"
import Studio from "features/studio/Studio"
import WithObjects from "data/wrappers/WithObjects"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"
import Container from "ui/components/Container"
import Section from "ui/components/Section"
import ObjectTable from "features/studio/components/ObjectTable"
import NewObjectButton from "features/studio/components/NewObjectButton"
export default class ObjectListPage extends React.Component {
    render() {
        return (
            <WithObjects>
                {({ objects, createObject }) => (
                    <Studio>
                        <Container marginBottom="medium" spaced>
                            <Section margin="none" padding="none">
                                <Breadcrumbs
                                    crumbs={[
                                        { label: "Data" }
                                    ]}
                                />
                                <PageTitle>Tables</PageTitle>
                            </Section>
                            <NewObjectButton onSave={createObject} />
                        </Container>
                        <ObjectTable data={objects} />
                    </Studio>
                )}
            </WithObjects>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/ObjectListPage.js